import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getSlots } from 'helpers/ApplicationHelper';
import MultipleButtons from 'components/chatBot/messageTypes/multipleButtons';

class SchedulePickupTime extends Component {
    constructor(props) {
        super(props);

        this.state = {
            multipleButtons: Object.assign({}, this.props.message, {buttons: [], stickyButtons: []}),
        };

        this.nextSlots = this.nextSlots.bind(this);
        this.setStickyButtons = this.setStickyButtons.bind(this);
        this.buttonsClick = this.buttonsClick.bind(this);
    }

// upgrade change
    componentDidMount() {
        this.nextSlots();
        if(this.props.message.stickyButtons){
            this.setStickyButtons();
        }
    }

    setStickyButtons(){
        let stickyButtons = this.state.multipleButtons.stickyButtons;
        let newButton = {
            text: this.props.message.stickyButtons.text,
            default_response: "fedex_drop_off_locations"
        };
        if(this.props.message.other.update_state) {
            newButton.update_state = this.props.message.stickyButtons.update_state;
        }
        stickyButtons.push(newButton);
        this.setState({stickyButtons});
    }

    nextSlots() {
        // TODO: may be united with listing page schedule shipment method

        const { item, Session } = this.props;

        let buttons = this.state.multipleButtons.buttons.filter(button => button.action && button.action === 'load_more');
        let availableSlots = getSlots(item.shipment.pickup_availability, Session.userData.local_time);

        let additionalButtons = availableSlots.map(slot => {
            return {
                text: `<div class=\"day\">${slot.dayText}</div> <div>${slot.timeText}</div>`,
                update_state: {
                    pickupPreferences: {
                        readyTimestamp: slot.readyTimestamp,
                        companyCloseTime: slot.companyCloseTime,
                        timeText: `${slot.dayText} ${slot.timeText}`,
                        earlySlot: slot.earlySlot
                    }
                },
                response: [
                    {
                        key: `message_schedule_pickup_level`,
                        direction: "2",
                        type: "message",
                        text: `${slot.dayText} ${slot.timeText} is perfect.`,
                        hide_waves_timeout: "2500",
                        time_to_show: "1800"
                    }
                ],
                default_response: "fedex_arrange_response"
            };
        });
        buttons = buttons.concat(additionalButtons);

        let message = this.props.message;
            message.text =  `Pickup time slots shown to the seller: ${buttons.length}`;

        if (buttons.length > 0) {
            message.text += buttons.map(btn => btn['text']).join('');
        }

        // Add Other option
        let newButton = {
            text: this.props.message.other.text,
            default_response: "fedex_more_slots"
        };
        if(this.props.message.other.update_state) {
            newButton.update_state = this.props.message.other.update_state;
        }
        buttons.push(newButton);

        this.setState({multipleButtons: Object.assign({}, this.state.multipleButtons, {buttons: buttons})});
    }

    buttonsClick(message, button) {
        if (button.action && button.action === 'load_more') {
            this.nextSlots();
            return;
        }
        this.props.onClick(message, button);
    }

    render(){
        return (
            <div>
                <MultipleButtons id={this.props.id} message={this.state.multipleButtons} onClick={this.buttonsClick} />
            </div>
        );
    }
}

const mapStateToProps = ({Session, Item}) => {

    return {
        Session,
        item: Item
    }
};

export default connect(mapStateToProps)(SchedulePickupTime);